<script setup>
  import Setup from './Setup.vue';  
  import {useDesignLabStore} from "../DesignLabStore.js"
  import {GetImageUrl} from "~/javascripts/utils.js";
  import { ref } from 'vue'

  const brandFontIconPath = GetImageUrl("icons/brand_font_icon.svg")
  const designLabStore = useDesignLabStore(); 
  const shareUrlInput = ref(null);
  const isCopySuccess = ref(false);

  const copyShareUrl = ()=>{
    if(isCopySuccess.value) return;
    shareUrlInput.value.select();
    shareUrlInput.value.setSelectionRange(0, 99999);
    document.execCommand('copy');
    shareUrlInput.value.setSelectionRange(0, 0);
    shareUrlInput.value.blur();
    isCopySuccess.value = true
    setTimeout(() => {
      isCopySuccess.value = false;
    }, 2000)
  }
</script>

<template>
  <Setup title="分享設計">
    <template #content>
      <div class="design-lab-share">
        <div class="design-lab-share__top">
          <img :src="brandFontIconPath">
          <div>恭喜您！完成了一個超棒的設計</div>
          <h4 class="text-break">{{ designLabStore.designNameCache }}</h4>
          <div>點擊<a @click="designLabStore.gotoURLNoNotify('/users/designs')" class="brand-link" title="前往我的設計">我的設計</a>進入查看</div>
        </div>

        <div class="design-lab-share__bottom">
          <div class="input-group mb-3">
            <div class="filter-copy-input" @click="copyShareUrl()"></div>
            <input type="text" class="form-control mk-form-control" readonly="readonly" :value="designLabStore.design.share_url" ref="shareUrlInput">
            <button v-if="!isCopySuccess" class="mk-btn" type="button" @click="copyShareUrl()" title="複製連結">複製連結</button>
            <button v-else class="mk-btn is-inactive">
              連結複製成功
            </button>
          </div>
          <div>或者將這個設計分享給你的夥伴或社群。</div>
        </div>
      </div>
    </template>
  </Setup>
</template>

<style lang="scss" scoped>
.design-lab-share {
  margin: 3rem auto 0;
  width: 75%;
  text-align: center;
  &__top {
    margin-bottom: 3rem;
    img {
      margin-bottom: 1rem;
    }
    h4 {
      margin: 1.5rem 0;
    }
  }
}

@media screen and (max-width:767px){
  .design-lab-share {
    &__top {
      margin-bottom: 3.375rem;
      img {
        margin-bottom: 1.25rem;
      }
      h4 {
        margin: 1.875rem;
        font-size: 0.9rem;
      }
    }
    &__bottom {
      > div:last-of-type {
        margin-top: 1.25rem;
      }
    }
  }
}


.filter-copy-input + input {
  &:focus {
    border: 1px solid #ced4da;
  }
}

.filter-copy-input {
  position: absolute;
  background: rgba(0,0,0,0);
  z-index: 5;
  top: 0px;
  left: 0;  
  width: calc(100% - 88px);
  height: 40px;
  cursor: pointer;
}

.is-inactive {
  cursor: default;
  pointer-events: none;
}

</style>